/*
 * ----------------------------------------------------------------
 * Start of Editable Code for new supplements
 * ----------------------------------------------------------------
 */

export const AMPLIFY_TID = ['p-sup-amp'] as const;
export const VITALITY_TID = ['p-sup-vit'] as const;
export const RESTORE_TID = ['p-sup-res'] as const;
export const SHARPEN_TID = ['p-sup-sha'] as const;
export const DEFEND_TID = ['p-sup-def'] as const;
export const NAD_TID = ['p-sup-nad'] as const;
export const MEMBER_TID = ['p-mem', 'p-mem-legacy'] as const;

export const AMPLIFY_BOTTLE_VARIANT_TID = 'pv-sup-btl-amp' as const;
export const AMPLIFY_POUCH_VARIANT_TID = 'pv-sup-pch-amp' as const;
export const VITALITY_BOTTLE_VARIANT_TID = 'pv-sup-btl-vit' as const;
export const VITALITY_POUCH_VARIANT_TID = 'pv-sup-pch-vit' as const;
export const RESTORE_BOTTLE_VARIANT_TID = 'pv-sup-btl-res' as const;
export const RESTORE_POUCH_VARIANT_TID = 'pv-sup-pch-res' as const;
export const SHARPEN_BOTTLE_VARIANT_TID = 'pv-sup-btl-sha' as const;
export const SHARPEN_POUCH_VARIANT_TID = 'pv-sup-pch-sha' as const;
export const DEFEND_BOTTLE_VARIANT_TID = 'pv-sup-btl-def' as const;
export const DEFEND_POUCH_VARIANT_TID = 'pv-sup-pch-def' as const;
export const NAD_BOTTLE_VARIANT_TID = 'pv-sup-btl-nad' as const;
export const NAD_POUCH_VARIANT_TID = 'pv-sup-pch-nad' as const;

export const MEMBER_VARIANT_TID = 'pv-mem' as const;
export const MEMBER_LEGACY_VARIANT_TID = 'pv-mem-legacy' as const;
export const TESTKIT_RECUR_VARIANT_TID = 'pv-tk-recur' as const;

export const membershipVariantIds = [MEMBER_VARIANT_TID, MEMBER_LEGACY_VARIANT_TID];

export const supplementBottles = [
  {productTid: AMPLIFY_TID[0], variantTid: AMPLIFY_BOTTLE_VARIANT_TID, displayName: 'Amplify'},
  {productTid: VITALITY_TID[0], variantTid: VITALITY_BOTTLE_VARIANT_TID, displayName: 'Vitality'},
  {productTid: RESTORE_TID[0], variantTid: RESTORE_BOTTLE_VARIANT_TID, displayName: 'Restore'},
  {productTid: SHARPEN_TID[0], variantTid: SHARPEN_BOTTLE_VARIANT_TID, displayName: 'Sharpen'},
  {productTid: DEFEND_TID[0], variantTid: DEFEND_BOTTLE_VARIANT_TID, displayName: 'Defend'},
  {productTid: NAD_TID[0], variantTid: NAD_BOTTLE_VARIANT_TID, displayName: 'NAD+'},
];

export const supplementPouches = [
  {productTid: AMPLIFY_TID[0], variantTid: AMPLIFY_POUCH_VARIANT_TID, displayName: 'Amplify'},
  {productTid: VITALITY_TID[0], variantTid: VITALITY_POUCH_VARIANT_TID, displayName: 'Vitality'},
  {productTid: RESTORE_TID[0], variantTid: RESTORE_POUCH_VARIANT_TID, displayName: 'Restore'},
  {productTid: SHARPEN_TID[0], variantTid: SHARPEN_POUCH_VARIANT_TID, displayName: 'Sharpen'},
  {productTid: DEFEND_TID[0], variantTid: DEFEND_POUCH_VARIANT_TID, displayName: 'Defend'},
  {productTid: NAD_TID[0], variantTid: NAD_POUCH_VARIANT_TID, displayName: 'NAD+'},
];

export const supplementCollection = [...supplementBottles, ...supplementPouches];

export const PRODUCT_TIDs = Array.from(
  new Set(supplementCollection.map(supplement => supplement.productTid)),
);
export const VARIANT_TIDs = supplementCollection.map(supplement => supplement.variantTid);
export const SUPPLEMENT_BOTTLE_VARIANT_TIDS = supplementBottles.map(
  supplement => supplement.variantTid,
);
export const SUPPLEMENT_POUCH_VARIANT_TIDS = supplementBottles.map(
  supplement => supplement.variantTid,
);

/*
 * ------------------------------------------------------------
 * End of Editable Code for new supplements
 * ------------------------------------------------------------
 */

export const CTA_DISPLAY_NAME = Object.fromEntries(
  supplementBottles.map(supplement => [supplement.productTid, supplement.displayName]),
);

export type Supplement = {
  productTid: string;
  variantTid: string;
  title: string;
  managePlanImage: string;
  skipNextOrderImage: string;
};

export const supplements: Supplement[] = supplementBottles.map(supplement => ({
  productTid: supplement.productTid,
  variantTid: supplement.variantTid,
  title: supplement.displayName,
  managePlanImage: `/image/profile/manage-plan/${supplement.displayName.toLowerCase()}-manage-plan.png`,
  skipNextOrderImage: `/image/profile/skip-next-order/${supplement.displayName.toLowerCase()}-skip.png`,
}));
